"use client";

import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { UserRound } from "lucide-react";
import Image from "next/image";
import { UpdateUserFormInputType } from "../schemas/update-user.schema";

function UpdateUserProfileImage() {
  const {
    control,
    formState: { errors },
    watch,
    setError,
  } = useFormContext<UpdateUserFormInputType>();

  const fieldName = "profilePicture";
  const image = watch(fieldName);
  const profilePictureErrorMessage = errors?.profilePicture?.message?.toString();

  const imagePreview = useMemo(
    () =>
      image
        ? typeof image === "string"
          ? image
          : URL.createObjectURL(image)
        : null,
    [image]
  );

  return (
    <div className="flex flex-col gap-3">
      <label
        htmlFor="update-user-profile-image-id"
        className="flex gap-1 cursor-pointer items-center"
      >
        <div
          className="
            w-[100px] aspect-square rounded-full  
            bg-gray-200  
            flex items-center justify-center relative
            cursor-pointer overflow-hidden mx-auto
          "
        >
          {imagePreview ? (
            <Image
              src={imagePreview}
              alt="Profile"
              className="w-full h-full object-cover"
              width={200}
              height={200}
            />
          ) : (
            <UserRound size={50} className="text-gray-500" />
          )}
          <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
              <input
                type="file"
                ref={field.ref}
                name={field.name}
                onBlur={field.onBlur}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    if (!file.type.includes("image")) {
                      setError(fieldName, { message: "File should be an image" });
                      return;
                    }
                    setError(fieldName, { message: "" });
                    field.onChange(file);
                  }
                }}
                className="hidden"
                id="update-user-profile-image-id"
              />
            )}
          />
        </div>
      </label>
      <p className="text-destructive text-sm text-center">
        {profilePictureErrorMessage}
      </p>
    </div>
  );
}

export default UpdateUserProfileImage;
